/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type MultiUserGroupVehicleGroupAssignmentCreate,
    MultiUserGroupVehicleGroupAssignmentCreateFromJSON,
    MultiUserGroupVehicleGroupAssignmentCreateToJSON,
} from '../models/MultiUserGroupVehicleGroupAssignmentCreate';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type UserGroupVehicleGroupAssignment,
    UserGroupVehicleGroupAssignmentFromJSON,
    UserGroupVehicleGroupAssignmentToJSON,
} from '../models/UserGroupVehicleGroupAssignment';
import {
    type UserGroupVehicleGroupAssignmentCreate,
    UserGroupVehicleGroupAssignmentCreateFromJSON,
    UserGroupVehicleGroupAssignmentCreateToJSON,
} from '../models/UserGroupVehicleGroupAssignmentCreate';
import {
    type UserGroupVehicleGroupAssignmentSortKey,
    UserGroupVehicleGroupAssignmentSortKeyFromJSON,
    UserGroupVehicleGroupAssignmentSortKeyToJSON,
} from '../models/UserGroupVehicleGroupAssignmentSortKey';

export interface UserGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequest {
    multiUserGroupVehicleGroupAssignmentCreate: MultiUserGroupVehicleGroupAssignmentCreate;
}

export interface UserGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequest {
    userGroupVehicleGroupAssignmentCreate: UserGroupVehicleGroupAssignmentCreate;
}

export interface UserGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequest {
    assignmentId: string;
}

export interface UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequest {
    pageSize: number;
    userGroupId?: string | null;
    vehicleGroupId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: UserGroupVehicleGroupAssignmentSortKey;
}

export interface UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequest {
    pageSize: number;
    userGroupId?: string | null;
    vehicleGroupId?: string | null;
}

export interface UserGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequest {
    assignmentId: string;
}

export interface UserGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequest {
    userGroupVehicleGroupAssignmentCreate: UserGroupVehicleGroupAssignmentCreate;
}

/**
 * UserGroupVehicleGroupAssignmentsApi - interface
 * 
 * @export
 * @interface UserGroupVehicleGroupAssignmentsApiInterface
 */
export interface UserGroupVehicleGroupAssignmentsApiInterface {
    /**
     * Creates request options for userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignment without sending the request
     * @param {MultiUserGroupVehicleGroupAssignmentCreate} multiUserGroupVehicleGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * This endpoint accepts a list of `UserGroup` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `UserGroup` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * @summary Create multiple user group vehicle group assignment
     * @param {MultiUserGroupVehicleGroupAssignmentCreate} multiUserGroupVehicleGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupVehicleGroupAssignment>>>;

    /**
     * This endpoint accepts a list of `UserGroup` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `UserGroup` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple user group vehicle group assignment
     */
    userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupVehicleGroupAssignment>>;

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignment without sending the request
     * @param {UserGroupVehicleGroupAssignmentCreate} userGroupVehicleGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new user group vehicle group assignment.
     * @summary Create a user group vehicle group assignment
     * @param {UserGroupVehicleGroupAssignmentCreate} userGroupVehicleGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupVehicleGroupAssignment>>;

    /**
     * Create a new user group vehicle group assignment.
     * Create a user group vehicle group assignment
     */
    userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupVehicleGroupAssignment>;

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignment without sending the request
     * @param {string} assignmentId 
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the user group vehicle group assignment with the given ID.
     * @summary Delete a user group vehicle group assignment
     * @param {string} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the user group vehicle group assignment with the given ID.
     * Delete a user group vehicle group assignment
     */
    userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignments without sending the request
     * @param {number} pageSize 
     * @param {string} [userGroupId] 
     * @param {string} [vehicleGroupId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupVehicleGroupAssignmentSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the `UserGroupVehicleGroupAssignment` present.
     * @summary List `UserGroupVehicleGroupAssignment`
     * @param {number} pageSize 
     * @param {string} [userGroupId] 
     * @param {string} [vehicleGroupId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupVehicleGroupAssignmentSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRaw(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupVehicleGroupAssignment>>>;

    /**
     * Lists all the `UserGroupVehicleGroupAssignment` present.
     * List `UserGroupVehicleGroupAssignment`
     */
    userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignments(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupVehicleGroupAssignment>>;

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [userGroupId] 
     * @param {string} [vehicleGroupId] 
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary `UserGroupVehicleGroupAssignment`  listing metadata
     * @param {number} pageSize 
     * @param {string} [userGroupId] 
     * @param {string} [vehicleGroupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRaw(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * `UserGroupVehicleGroupAssignment`  listing metadata
     */
    userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadata(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignment without sending the request
     * @param {string} assignmentId 
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the `UserGroupVehicleGroupAssignment` specified by the given ID.
     * @summary Get a single `UserGroupVehicleGroupAssignment`
     * @param {string} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupVehicleGroupAssignment>>;

    /**
     * Returns the `UserGroupVehicleGroupAssignment` specified by the given ID.
     * Get a single `UserGroupVehicleGroupAssignment`
     */
    userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupVehicleGroupAssignment>;

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignment without sending the request
     * @param {UserGroupVehicleGroupAssignmentCreate} userGroupVehicleGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new `UserGroupVehicleGroupAssignment` without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a `UserGroupVehicleGroupAssignment`
     * @param {UserGroupVehicleGroupAssignmentCreate} userGroupVehicleGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupVehicleGroupAssignmentsApiInterface
     */
    userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new `UserGroupVehicleGroupAssignment` without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a `UserGroupVehicleGroupAssignment`
     */
    userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class UserGroupVehicleGroupAssignmentsApi extends runtime.BaseAPI implements UserGroupVehicleGroupAssignmentsApiInterface {

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignment without sending the request
     */
    async userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['multiUserGroupVehicleGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'multiUserGroupVehicleGroupAssignmentCreate',
                'Required parameter "multiUserGroupVehicleGroupAssignmentCreate" was null or undefined when calling userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_vehicle_group_assignments/multi`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MultiUserGroupVehicleGroupAssignmentCreateToJSON(requestParameters['multiUserGroupVehicleGroupAssignmentCreate']),
        };
    }

    /**
     * This endpoint accepts a list of `UserGroup` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `UserGroup` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple user group vehicle group assignment
     */
    async userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupVehicleGroupAssignment>>> {
        const requestOptions = await this.userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserGroupVehicleGroupAssignmentFromJSON));
    }

    /**
     * This endpoint accepts a list of `UserGroup` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `UserGroup` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple user group vehicle group assignment
     */
    async userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupVehicleGroupAssignment>> {
        const response = await this.userGroupVehicleGroupAssignmentsCreateMultipleUserGroupVehicleGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignment without sending the request
     */
    async userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupVehicleGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'userGroupVehicleGroupAssignmentCreate',
                'Required parameter "userGroupVehicleGroupAssignmentCreate" was null or undefined when calling userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_vehicle_group_assignments/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupVehicleGroupAssignmentCreateToJSON(requestParameters['userGroupVehicleGroupAssignmentCreate']),
        };
    }

    /**
     * Create a new user group vehicle group assignment.
     * Create a user group vehicle group assignment
     */
    async userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupVehicleGroupAssignment>> {
        const requestOptions = await this.userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupVehicleGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Create a new user group vehicle group assignment.
     * Create a user group vehicle group assignment
     */
    async userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupVehicleGroupAssignment> {
        const response = await this.userGroupVehicleGroupAssignmentsCreateUserGroupVehicleGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignment without sending the request
     */
    async userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_vehicle_group_assignments/{assignment_id}`;
        urlPath = urlPath.replace('{assignment_id}', encodeURIComponent(String(requestParameters['assignmentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the user group vehicle group assignment with the given ID.
     * Delete a user group vehicle group assignment
     */
    async userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the user group vehicle group assignment with the given ID.
     * Delete a user group vehicle group assignment
     */
    async userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupVehicleGroupAssignmentsDeleteUserGroupVehicleGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignments without sending the request
     */
    async userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userGroupId'] != null) {
            queryParameters['user_group_id'] = requestParameters['userGroupId'];
        }

        if (requestParameters['vehicleGroupId'] != null) {
            queryParameters['vehicle_group_id'] = requestParameters['vehicleGroupId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_vehicle_group_assignments/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the `UserGroupVehicleGroupAssignment` present.
     * List `UserGroupVehicleGroupAssignment`
     */
    async userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRaw(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroupVehicleGroupAssignment>>> {
        const requestOptions = await this.userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserGroupVehicleGroupAssignmentFromJSON));
    }

    /**
     * Lists all the `UserGroupVehicleGroupAssignment` present.
     * List `UserGroupVehicleGroupAssignment`
     */
    async userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignments(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroupVehicleGroupAssignment>> {
        const response = await this.userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadata without sending the request
     */
    async userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['userGroupId'] != null) {
            queryParameters['user_group_id'] = requestParameters['userGroupId'];
        }

        if (requestParameters['vehicleGroupId'] != null) {
            queryParameters['vehicle_group_id'] = requestParameters['vehicleGroupId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_vehicle_group_assignments/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * `UserGroupVehicleGroupAssignment`  listing metadata
     */
    async userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRaw(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * `UserGroupVehicleGroupAssignment`  listing metadata
     */
    async userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadata(requestParameters: UserGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.userGroupVehicleGroupAssignmentsListUserGroupVehicleGroupAssignmentsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignment without sending the request
     */
    async userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['assignmentId'] == null) {
            throw new runtime.RequiredError(
                'assignmentId',
                'Required parameter "assignmentId" was null or undefined when calling userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_vehicle_group_assignments/{assignment_id}`;
        urlPath = urlPath.replace('{assignment_id}', encodeURIComponent(String(requestParameters['assignmentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the `UserGroupVehicleGroupAssignment` specified by the given ID.
     * Get a single `UserGroupVehicleGroupAssignment`
     */
    async userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupVehicleGroupAssignment>> {
        const requestOptions = await this.userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupVehicleGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Returns the `UserGroupVehicleGroupAssignment` specified by the given ID.
     * Get a single `UserGroupVehicleGroupAssignment`
     */
    async userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupVehicleGroupAssignment> {
        const response = await this.userGroupVehicleGroupAssignmentsReadUserGroupVehicleGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignment without sending the request
     */
    async userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequestOpts(requestParameters: UserGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupVehicleGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'userGroupVehicleGroupAssignmentCreate',
                'Required parameter "userGroupVehicleGroupAssignmentCreate" was null or undefined when calling userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_group_vehicle_group_assignments/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupVehicleGroupAssignmentCreateToJSON(requestParameters['userGroupVehicleGroupAssignmentCreate']),
        };
    }

    /**
     * Validate data for a new `UserGroupVehicleGroupAssignment` without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a `UserGroupVehicleGroupAssignment`
     */
    async userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRaw(requestParameters: UserGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new `UserGroupVehicleGroupAssignment` without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a `UserGroupVehicleGroupAssignment`
     */
    async userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignment(requestParameters: UserGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupVehicleGroupAssignmentsValidateCreateUserGroupVehicleGroupAssignmentRaw(requestParameters, initOverrides);
    }

}
